/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {KTableProvider, useKTable} from '../../../../../../../../contexts/KTableProvider'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../../../components/UI'
import {FC, useEffect, useState} from 'react'
import {KTCard, KTSVG} from '../../../../../../../../../../_metronic/helpers'
import {TypeClothe, Out, MasiveOut} from '../../../../../../model'
import {SelectAsync} from '../../../../../../../../components/UI/SelectV2'
import {
  getLaundryById,
  getReceptionByLaundry,
  getOrderOut,
  getPrintOrderOut,
  getSendEmailOut,
} from '../../../../../../services'
import {createOutLaundry} from '../../../../../../services'
import {InputDate, InputText} from '../../../../../../../../components/UI/Input'
import {Select} from '../../../../../../../../components/UI/Select'
import {useForm, FormProvider} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {ModalAddSalida} from '../modal/ModalAddSalida'
import {useLavanderia} from '../../../../../../../../hooks/useLavanderia'
import Swal from 'sweetalert2'
import {schemaOrderLaundryOut} from '../../../../../../../../util/validationLavanderia'
import {getMasterService} from '../../../../../../../central/services'
import {ModalTicket} from '../../../../../componentes/Modal/ModalTicket'
import {paginationGuestsService} from '../../../../../../../hoteleria/features/guests/services'
import {ShowSnackBar} from '../../../../../../../../util/functions'
import moment from 'moment'
const TableOut: FC = () => {
  const {data, setData, setPagination, loading, setLoading, clearSelected, pagination} = useKTable()
  const {currentTabItem, isAllowed} = useLavanderia()
  const methods = useForm<Out>({
    resolver: yupResolver(schemaOrderLaundryOut),
  })
  const [showModalPrint, setShowModalPrint] = useState(false)
  const [typeFurniture, setTypeFurniture] = useState<Out[] | any>([])
  const [idReception, setIdReception] = useState<any>(null)
  const [showModalNew, setShowModalNew] = useState(false)
  const [minLength, setMinLength] = useState<string>('')
  const [idPermission, setIdPermission] = useState<any>('')
  const [idSalida, setIdSalida] = useState<any>(null)
  const [detailpermission, setDetailPermission] = useState<TypeClothe | any>(null)
  const [showOption, setShowOption] = useState<boolean>(false)
  const [detailPrint, setDetailPrint] = useState<any>(null)
  const [bolsaCorrelativo, setBolsaCorrelativo] = useState<string>('')
  const [rotuladoCorrelativo, setRotuladoCorrelativo] = useState<string>('')

  const {
    control,
    setValue,
    handleSubmit,
    setError,
    register,
    watch,
    formState: {errors},
  } = methods
  const getOrderPrint = async () => {
    try {
      const response = await getOrderOut(currentTabItem.idToEdit)
      const data = response.data.data
      setBolsaCorrelativo(data.bolsaCorrelativo)
      setRotuladoCorrelativo(data.rotuladoCorrelativo)
      setDetailPrint(data)
      setShowModalPrint(true)
    } catch (error) {}
  }
  const handleClear = () => {
    setIdPermission('')
  }
  const getLaundryByIdList = async () => {
    setLoading(true)
    const response = await getLaundryById(currentTabItem.idToEdit)
    const data = response.data.data
    setValue('campamentoId', data.campamentoId)
    setLoading(false)
    setValue('nroOrdenLoteSalida', data.nroOrdenLoteLavado)
    const fechaLocalProgramada = data.salida.fechaSalida ? new Date(data.salida.fechaSalida) : null
    const formattedDateProgramada = fechaLocalProgramada
      ? fechaLocalProgramada.toISOString().slice(0, 10)
      : moment().format('YYYY-MM-DD')
    setValue('fechaSalida', formattedDateProgramada)
    const fechaLocal = data.procesoLavado.fechaRealSalida
      ? new Date(data.procesoLavado.fechaRealSalida)
      : null
    const formattedDate = fechaLocal ? fechaLocal.toISOString().slice(0, 10) : ''
    const fechaLocalDevolucion = data.procesoLavado.fechaDevolucionReal
      ? new Date(data.procesoLavado.fechaDevolucionReal)
      : null
    const formattedDateDevolucion = fechaLocalDevolucion
      ? fechaLocalDevolucion.toISOString().slice(0, 10)
      : ''

    if (data.procesoLavado.lugarLavado === 'LAVADO EN SITE') {
      setValue('fechaRecepcion', formattedDate)
    } else {
      setValue('fechaRecepcion', formattedDateDevolucion)
    }
    let lugarSalida = data.salida.lugarSalida ? data.salida.lugarSalida : ''
    setValue('lugarSalida', lugarSalida)
    if (data.procesoLavado.fechaRealSalida || data.procesoLavado.fechaDevolucionReal) {
      setIdReception(data.procesoLavado.id)
    }
    setValue('recepcionId', data.recepcion.id)
    if (data.salida.id) {
      setShowOption(false)
      setIdSalida(data.salida.id)
      getReceptionByLaundryList(data.recepcion.id, data.bolsaCorrelativo, data.rotuladoCorrelativo)

      setValue('responsable', data.salida.responsable)
      setValue('responsableId', data.salida.responsableId)
      setMinLength(formattedDate)
    } else {
      setShowOption(true)

      let addIdData = data.detalle?.map((item, index) => {
        return {idRopa: index + 1, ...item}
      })
      setData(addIdData)
      setValue('responsable', data.recepcion.responsable)
      setValue('responsableId', data.recepcion.responsableId)
      setMinLength(formattedDate)
      let countTotal =
        data.detalle?.reduce(
          (acumulador: any, elemento: any) => acumulador + elemento.cantidad,
          0,
        ) || 0
      let sumWeight =
        data.detalle?.reduce((acumulador: any, elemento: any) => acumulador + elemento.peso, 0) || 0
      setValue('pesoTotal', sumWeight)
      setValue('cantidadTotal', countTotal)
      setValue('bolsaCorrelativo', data.bolsaCorrelativo)
      setValue('rotuladoCorrelativo', data.rotuladoCorrelativo)
    }
  }
  const getReceptionByLaundryList = async (
    id: any,
    bolsaCorrelativo: string,
    rotuladoCorrelativo: string,
  ) => {
    try {
      clearSelected()
      setLoading(true)
      const {data: response} = await getReceptionByLaundry(id, pagination.currentPage)
      if (!response.error) {
        let addIdData = response.data?.map((item, index) => {
          return {idRopa: index + 1, ...item}
        })
        setData(addIdData)

        setPagination({
          ...pagination,
          totalResults: response.total,
        })
        let countTotal =
          response.data?.reduce(
            (acumulador: any, elemento: any) => acumulador + elemento.cantidad,
            0,
          ) || 0
        let sumWeight =
          response.data?.reduce(
            (acumulador: any, elemento: any) => acumulador + elemento.peso,
            0,
          ) || 0

        setValue('pesoTotal', sumWeight)
        setValue('cantidadTotal', countTotal)
        setValue('bolsaCorrelativo', bolsaCorrelativo)
        setValue('rotuladoCorrelativo', rotuladoCorrelativo)
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const getReceptionPlaceList = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'LugarEntrega',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.codigo,
        label: master.nombreCorto,
      }))
      setTypeFurniture(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }

  useEffect(() => {
    getLaundryByIdList()
    getReceptionPlaceList()
  }, [])

  const handleEdit = (item: TypeClothe) => {
    const filter = data.filter((detail) => detail.id === item.id)
    setDetailPermission(filter[0])
    setIdPermission(item.id)
    setShowModalNew(true)
  }

  const columns: Column<TypeClothe>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} title='Item' />,
      accessor: 'idRopa',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de ropa' />,
      accessor: 'tipoRopa',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Cantidad' />,
      accessor: 'cantidad',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Peso KG' />,
      accessor: 'peso',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Observaciones' />,
      accessor: 'observaciones',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
      id: 'actions',
      Cell: ({...props}) => (
        <>
          {isAllowed('SALIDA/EDITAR')
            ? showOption && (
                <div
                  className='d-flex justify-content-center flex-shrink-0'
                  onClick={() => handleEdit(props.data[props.row.index])}
                >
                  <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                    <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
                  </a>
                </div>
              )
            : null}
        </>
      ),
    },
  ]

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  const handleGetName = (e: any) => {
    setValue('responsable', e.label)
    setValue('responsableId', e.value)
    setError('responsableId', {})
  }
  const onSubmitOut = async (dataInfo: Out) => {
    try {
      Swal.fire({
        title: '¿Estás seguro?',
        text: 'Al finalizar la salida no podrás revertir esta acción',
        //showDenyButton: true,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, finalizar',
        confirmButtonColor: 'var(--kt-primary)',
        //denyButtonText: `Don't save`,
        cancelButtonText: 'No',
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
      }).then(async (result) => {
        /* Read more about isConfirmed, isDenied below */

        if (result.isConfirmed) {
          setLoading(true)
          let obj = {
            detalle: data,
            ordenId: currentTabItem.idToEdit,
            lugarSalida: dataInfo.lugarSalida,
            responsable: dataInfo.responsable,
            responsableId: dataInfo.responsableId,
            fechaRecepcion: dataInfo.fechaRecepcion,
            fechaSalida: dataInfo.fechaSalida,
            cantidadTotal: dataInfo.cantidadTotal,
            pesoTotal: dataInfo.pesoTotal,
          }
          const {data: response} = await createOutLaundry(obj)
          if (!response.error) {
            ShowSnackBar('Se registró satisfactoriamente')
            getLaundryByIdList()
            getOrderPrint()
          } else {
            ShowSnackBar(response.message, 'error')
          }
          getLaundryByIdList()
          Swal.close()
        } else if (result.isDenied) {
          //Swal.fire('Changes are not saved', '', 'info')
        }
      })
    } catch (error) {}
  }
  const onSubmit = async (data: MasiveOut) => {
    try {
      getOrderPrint()
    } catch (error) {}
  }
  const downloadPDF = async () => {
    try {
      const response = await getPrintOrderOut(currentTabItem.idToEdit)
      const blob = new Blob([response.data], {type: 'application/pdf'})
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'archivo.pdf' // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (error) {}
  }
  const sendEmail = async () => {
    try {
      const {data: response} = await getSendEmailOut(currentTabItem.idToEdit)
      if (!response.error) {
        ShowSnackBar('Se envío satisfactoriamente, revise su correo')
      } else {
        ShowSnackBar(response.message, 'error')
      }
    } catch (error) {}
  }
  const loadOptions = async (inputValue: string) => {
    try {
      if (inputValue.length < 3) {
        return []
      }
      const {data: response} = await paginationGuestsService({
        pageNumber: 1,
        size: 2000,
        isCombo: true,
        CampamentoId: watch('campamentoId') || '',
        BuscaTexto: inputValue,
      })
      if (!response.error) {
        const mappedGuests = response.data?.map((guest) => ({
          value: guest.Id,
          label: `${guest.Nombres} ${guest.ApellidoPaterno} ${guest.ApellidoMaterno}`,
        }))
        return mappedGuests
      } else {
        return []
      }
    } catch (error) {
      console.error('Error fetching options:', error)
      return []
    }
  }
  let isDisabled = idReception ? false : true
  const isEdit = currentTabItem.aditionalInformation?.order?.isView ? true : idSalida

  return (
    <KTCard shadow className='m-5'>
      <div className='p-2'>
        <FormProvider {...methods}>
          <form>
            {isAllowed('SALIDA/FINALIZAR_SALIDA') && (
              <div className='row'>
                <div className='mb-2 col-3'>
                  <label className='required'>Lugar de salida</label>
                  <Select
                    control={control}
                    name='lugarSalida'
                    data={typeFurniture}
                    errors={errors}
                    disabled={isEdit}
                  />
                </div>
                <div className='mb-2 col-3'>
                  <div className='d-flex'>
                    <label className='required'>Huésped(salida)</label>
                  </div>
                  <SelectAsync
                    name={'huespedId'}
                    loadOptions={loadOptions as any}
                    disabled={isEdit}
                    value={{
                      value: watch('responsableId') || '',
                      label: watch('responsable') || '',
                    }}
                    onChangeValue={handleGetName}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label>Fecha de recepción:</label>
                  <InputDate
                    name='fechaRecepcion'
                    register={register}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label>Fecha de salida Devolución al Huésped:</label>
                  <InputDate
                    name='fechaSalida'
                    register={register}
                    errors={errors}
                    minValue={minLength}
                    disabled={isEdit}
                  />
                </div>
              </div>
            )}
            <div className='row'>
              <div className='col-sm-12 col-lg-2'>
                <label>Cantidad total:</label>
                <InputText
                  name='cantidadTotal'
                  register={register}
                  errors={errors}
                  disabled={true}
                />
              </div>
              <div className='col-sm-12 col-lg-2'>
                <label>Peso total:</label>
                <InputText name='pesoTotal' register={register} errors={errors} disabled={true} />
              </div>
              <div className='col-sm-12 col-lg-2'>
                <label>Nro de Lote:</label>
                <InputText
                  name='nroOrdenLoteSalida'
                  register={register}
                  errors={errors}
                  disabled={true}
                />
              </div>
              <div className='col-sm-12 col-lg-2'>
                <label>Codigo de Bolsa:</label>
                <InputText
                  name='bolsaCorrelativo'
                  register={register}
                  errors={errors}
                  disabled={true}
                />
              </div>
              <div className='col-sm-12 col-lg-2'>
                <label>Rotulado:</label>
                <InputText
                  name='rotuladoCorrelativo'
                  register={register}
                  errors={errors}
                  disabled={true}
                />
              </div>
            </div>
            {currentTabItem.aditionalInformation?.order?.isView ? null : !idSalida ? (
              <div className='col-sm-12 col-lg-12 d-flex justify-content-end align-items-end'>
                <div className='d-flex justify-content-end'>
                  {isAllowed('SALIDA/FINALIZAR_SALIDA') && (
                    <button
                      type='button'
                      className='btn btn-primary me-3'
                      disabled={isDisabled}
                      onClick={handleSubmit(onSubmitOut)}
                    >
                      Finalizar Salida
                    </button>
                  )}
                </div>
              </div>
            ) : (
              <div className='col-sm-12 col-lg-12 d-flex justify-content-end align-items-end'>
                <div className='d-flex justify-content-end'>
                  {isAllowed('SALIDA/REIMPRIMIR') && (
                    <button
                      type='button'
                      className='btn btn-success me-3'
                      onClick={handleSubmit(onSubmit)}
                    >
                      Re-imprimir
                    </button>
                  )}
                </div>
              </div>
            )}
          </form>
        </FormProvider>
      </div>
      {isAllowed('SALIDA/LISTAR') && (
        <>
          <KTable data={data} columns={columns} />
          {loading ? <KTableLoading title='Cargando...' /> : null}
        </>
      )}
      <ModalAddSalida
        show={showModalNew}
        idReception={idReception}
        setShow={setShowModalNew}
        getReceptionByLaundryList={() =>
          getReceptionByLaundryList(
            watch('recepcionId'),
            watch('bolsaCorrelativo'),
            watch('rotuladoCorrelativo'),
          )
        }
        detailpermission={detailpermission}
        idPermission={idPermission}
        setIdPermissionList={handleClear}
      />
      <ModalTicket
        show={showModalPrint}
        setShow={setShowModalPrint}
        idPermission={''}
        nameTitle={'salida'}
        userTicket={'huesped'}
        data={detailPrint}
        funcSeePDF={downloadPDF}
        funcSendEmail={sendEmail}
      />
    </KTCard>
  )
}

const TableOutWrapper = () => {
  return (
    <KTableProvider>
      <TableOut />
    </KTableProvider>
  )
}
export {TableOutWrapper}
